module.exports = __webpack_public_path__ + "media/images/official/plancheck_icon_15_2-5f1046613d0fe2403aa76c328453c300.svg";